export const statusConstants = {
  PENDING : 0,
  INPROGRESS: 1,
  COMPLETED: 2,
  OPEN: 3,
  HOLD: 4,
  CLOSED: 5,
  PENDING_LABEL : "Pending",
  INPROGRESS_LABEL: "Inprogress",
  COMPLETED_LABEL: "Completed",
  OPEN_LABEL: "Open",
  HOLD_LABEL: "Hold",
  CLOSED_LABEL: "Closed"
};
